import {IconButton} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, {useEffect, useState} from 'react';
import {firestore} from '../../Firebase';
import Heading from '../../Heading/JavaScript/Heading';
import ProjectLeft from './ProjectLeft';
import ProjectRight from './ProjectRight';

function Projects() {
    const [disable, setDisable] = useState(false);
    const [moreLess, setMoreLess] = useState('More');
    const [projectsData, setProjectsData] = useState([]);
    const [first4Projects, setFirst4Projects] = useState([]);
    
    useEffect(
        () => {
            firestore.collection("Projects").onSnapshot(
                (snapShot) => (
                    setProjectsData(
                        snapShot.docs.map(
                            (doc) => (
                                {
                                    imageURL: doc.data().imageURL,
                                    name: doc.data().name,
                                    text: doc.data().text
                                }
                            )
                        )
                    )
                )
            )
        }, []
    )
    
    useEffect(
        () => {
            const temp = projectsData.slice(0, 4);
            
            setFirst4Projects(
                temp.map(
                    (doc) => (
                        {
                            imageURL: doc.imageURL,
                            name: doc.name,
                            text: doc.text
                        }
                    )
                )
            )
        }, [projectsData]
    )
    
    useEffect(
        () => {
            if (projectsData.length === 0) {
                let projectsSection = document.getElementsByClassName("projects")[0];
                
                projectsSection.style.display = "none";
            }
            else {
                let projectsSection = document.getElementsByClassName("projects")[0];
                
                projectsSection.style.display = "grid";
            }
        }, [projectsData.length]
    )
    
    const expand = () => {
        let projectsExpandButton = document.getElementsByClassName("projects__expand__button")[0];
        
        if (projectsData.length <= 4) {
            setDisable(true);
        }
        else {
            setDisable(false);
        }
        
        if (moreLess === "More") {
            projectsExpandButton.style.transform = "rotate(180deg)";
            setMoreLess("Less");
        }
        else {
            projectsExpandButton.style.transform = "rotate(0deg)";
            setMoreLess("More");
        }
    }
    
    return (
        <section className="projects">
            <div className="projects__heading">
                <Heading text="Projects" />
            </div>
            
            <div className="projects__container">
                {
                    (moreLess === "Less") ? (
                        React.Children.toArray(
                            projectsData.map(
                                (data, ID) => {
                                    if (ID % 2 === 0) {
                                        return (<ProjectRight data={data} />)
                                    }
                                    else {
                                        return (<ProjectLeft data={data} />)
                                    }
                                }
                            )
                        )
                    ) : (
                        React.Children.toArray(
                            first4Projects.map(
                                (data, ID) => {
                                    if (ID % 2 === 0) {
                                        return (<ProjectRight data={data} />)
                                    }
                                    else {
                                        return (<ProjectLeft data={data} />)
                                    }
                                }
                            )
                        )
                    )
                }
            </div>
            
            <IconButton className="projects__expand" onClick={expand} disabled={disable} data-aos="fade-down" data-aos-delay="4s00">
                <span className="projects__expand__text">Show {moreLess}</span>
                <ExpandMoreIcon className="projects__expand__button" />
            </IconButton>
        </section>
    )
}

export default Projects
